import React from 'react';
import { Language } from '../App';
interface FooterProps {
  language: Language;
}
const content = {
  en: {
    address: '116 Central Park South, New York, NY, 10019',
    email: 'contact@pearlannbrown.com',
    legal: 'Professional medical practice. Licensed physicians in New York State.',
    copyright: '© 2026 Pearl Ann Brown. All rights reserved.'
  },
  es: {
    address: '116 Central Park South, New York, NY, 10019',
    email: 'contact@pearlannbrown.com',
    legal: 'Práctica médica profesional. Médicos con licencia en el Estado de Nueva York.',
    copyright: '© 2026 Pearl Ann Brown. Todos los derechos reservados.'
  }
};
export function Footer({
  language
}: FooterProps) {
  const t = content[language];
  return <footer className="bg-espresso border-t border-pearl/10 py-12 px-4 sm:px-6 lg:px-8" data-id="element-77">
      <div className="max-w-7xl mx-auto" data-id="element-78">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-79">
          <div data-id="element-80">
            <h3 className="text-pearl text-xl font-bold mb-4" data-id="element-81">
              PEARL ANN BROWN
            </h3>
            <p className="text-pearl/60 text-sm" data-id="element-82">{t.legal}</p>
          </div>

          <div data-id="element-83">
            <h4 className="text-pearl font-semibold mb-3" data-id="element-84">
              {language === 'en' ? 'Contact' : 'Contacto'}
            </h4>
            <div className="space-y-2 text-pearl/60 text-sm" data-id="element-85">
              <p data-id="element-86">{t.address}</p>
              <p data-id="element-87">{t.email}</p>
            </div>
          </div>

          <div data-id="element-88">
            <h4 className="text-pearl font-semibold mb-3" data-id="element-89">
              {language === 'en' ? 'Hours' : 'Horario'}
            </h4>
            <p className="text-pearl/60 text-sm" data-id="element-90">
              {language === 'en' ? 'By Appointment Only' : 'Solo con Cita Previa'}
            </p>
          </div>
        </div>

        <div className="border-t border-pearl/10 pt-8 text-center" data-id="element-91">
          <p className="text-pearl/60 text-sm" data-id="element-92">{t.copyright}</p>
        </div>
      </div>
    </footer>;
}